module.exports = __webpack_public_path__ + "media/correct.56893856.wav";